import { NgModule } from '@angular/core';


import { EffectsModule } from '@ngrx/effects';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ChartsModule } from '../../shared/charts/charts.module';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../global/pipes/pipes.module';
import { ValuationsEffects } from './valuations.effects';
import { ValuationsContainerComponent } from './valuations.container';
import { CdkModule, DATE_FORMATS, DATE_LOCALE, DateAdapter, NativeDateAdapter } from 'atlas-cdk';
import { TableModule } from 'atlas-table';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { LegacyModule } from 'atlas-legacy';
import { FieldModule } from 'atlas-field';
import { PaginationModule } from 'atlas-pagination';
import { TooltipModule } from 'atlas-tooltip';
import { NavigationMenuModule } from 'atlas-navigation';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
import { AvatarModule } from 'atlas-avatar';
import { DrawerModule } from 'atlas-drawer';
export const COMPONENTS = [
  ValuationsContainerComponent
];

// const MY_DATE_FORMAT = {
//   parse: {
//     dateInput: 'dd/M/yyyy',
//   },
//   display: {
//     ateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
//     dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
//     monthYearA11yLabel: { year: 'numeric', month: 'long' },
//     monthYearLabel: { year: 'numeric', month: 'short' },
//   },
// };

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'dd LLL yyyy', // 11 July 2025
  },
  display: {
    dateInput: { year: 'numeric', month: 'long', day: 'numeric' }, // e.g. Jul 11, 2025 with 'en-GB'
    monthYearLabel: { year: 'numeric', month: 'long' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
@NgModule({
  declarations: COMPONENTS,
  imports: [
    FormsModule,
    CommonModule,
    ChartsModule,
    SharedModule,
    PipesModule,
    CdkModule,
    TableModule,
    IconModule,
    ButtonModule,
    LegacyModule,
    FieldModule,
    PaginationModule,
    TooltipModule,
    NavigationMenuModule,
    MenuModule,
    ListModule,
    LinkModule,
    AvatarModule,
    DrawerModule,
    EffectsModule.forFeature([ValuationsEffects])
  ],
  exports: COMPONENTS,

  providers: [

    { provide: DATE_LOCALE, useValue: 'en-GB' },
    { provide: DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ],
  bootstrap: [],
})
export class ValuationsModule {
}
